'use client';

import React, { type FC } from 'react';
import { formatCreditsNumber } from '../utils/formatters';
import { BonusCreditsCountUp } from './BonusCreditsCountUp';
import { FaBolt } from './icons';

interface BonusCreditsProps {
  amount: number;
  className?: string;
  showIcon?: boolean;
  iconSize?: number | string;
  iconOnly?: boolean;
  muted?: boolean;
  /** Overrides the bolt color — the default fuchsia is unreadable on magenta surfaces
   *  like `.bnc-btn-neon`, where the caller passes `text-white`. */
  iconClassName?: string;
  /** 'baseline' sits the icon on the surrounding text's baseline — for inline use next to prose. */
  align?: 'center' | 'baseline';
  /** Count from the previous amount up (or down) to the new one over 600ms instead of
   *  jumping straight to it. Mirrors `Credits`' `animateChange` — for the member's own
   *  spark balance only, off by default. Mounts `BonusCreditsCountUp`, which is the only
   *  place the extra hooks and the RAF tween live, so every other caller stays free of them. */
  animateChange?: boolean;
}

/** SHOT BAND spark counter — Credits' sibling. Magenta bolt instead of the gold coin
 *  so the club currency never reads as the main balance. */
export const BonusCredits: FC<BonusCreditsProps> = ({ amount, className, showIcon = true, iconSize = 12, iconOnly = false, muted = false, iconClassName, align = 'center', animateChange = false }) => {
  return (
    <span className={`inline-flex ${align === 'baseline' ? 'items-baseline' : 'items-center'} gap-1 ${className || ''}`}>
      {!iconOnly && (animateChange ? <BonusCreditsCountUp amount={amount} /> : formatCreditsNumber(amount))}
      {showIcon && <FaBolt className={`${iconClassName ?? (muted ? 'text-fuchsia-400/50' : 'text-fuchsia-400')} shrink-0`} size={iconSize} />}
    </span>
  );
};
